/* eslint-disable import/prefer-default-export */
import { css, keyframes } from "@emotion/react";

const blackedOut = keyframes`
  from, 0%, to {
    opacity: 100%;
  }
  
  50% {
    opacity: 50%;
 }
  
  100% {
    opacity: 100%;
 }
`;

const blackedOutCss = css`
  animation: ${blackedOut} 2s infinite;
`;

export const getBlackedOutCss = ({ isDataUpdating }) => isDataUpdating && blackedOutCss;
